import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "trash",
  "use": "trash-usage",
  "viewBox": "0 0 14 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 18\" id=\"trash\">\n    <path d=\"M8.176 5L8 15h1.824L10 5H8.176zM5.824 5H4l.176 10H6L5.824 5zm5.347 10.773l-.001.03c0 .056-.052.103-.116.103H3.17c-.064 0-.117-.047-.117-.104l-.4-11.082H.611l.401 11.099c.01 1.05.974 1.9 2.157 1.9h7.884c1.183 0 2.146-.85 2.156-1.9l.402-11.1H11.57l-.4 11.054zm-.927-13.808L9.881 0H3.939l-.364 1.965H0V4h14V1.965h-3.756z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol